export const getInitialState = ({data}) => { 
    const initialState = {
        name: data?.name ?? '',
        course: data?.course_id,
        direction: data?.direction_id,
        topic_id: data?.topic_id ?? null
    }

    return initialState;
}